import React, { useEffect, useState } from "react";
import { listarApiLogs } from "../services/api";
import { formatDateTimeBr } from "../utils/formatDateBr";

const AuditoriaApi = ({ token }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filtros, setFiltros] = useState({
    path: "",
    statusCode: "",
    revendaId: "",
  });

  const carregar = async (pagina = 1) => {
    setLoading(true);
    try {
      const params = { page: pagina, pageSize: 50 };
      if (filtros.path) params.path = filtros.path;
      if (filtros.statusCode) params.statusCode = Number(filtros.statusCode);
      if (filtros.revendaId) params.revendaId = Number(filtros.revendaId);

      const res = await listarApiLogs(token, params);
      setLogs(res.data?.items || []);
      setPage(res.data?.page || pagina);
      setTotalPages(res.data?.totalPages || 1);
    } catch (e) {
      console.error(e);
      alert("Erro ao carregar logs da API.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Auditoria HTTP (ApiLogs)</h1>
        <p className="text-sm text-gray-500 dark:text-slate-300">Requisições registradas pelo middleware de auditoria.</p>
      </div>

      <div className="zen-card rounded-2xl p-4 grid grid-cols-1 md:grid-cols-4 gap-3">
        <input
          className="px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10"
          placeholder="Path contém..."
          value={filtros.path}
          onChange={(e) => setFiltros((f) => ({ ...f, path: e.target.value }))}
        />
        <input
          className="px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10"
          placeholder="Status HTTP"
          value={filtros.statusCode}
          onChange={(e) => setFiltros((f) => ({ ...f, statusCode: e.target.value }))}
        />
        <input
          className="px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10"
          placeholder="RevendaId"
          value={filtros.revendaId}
          onChange={(e) => setFiltros((f) => ({ ...f, revendaId: e.target.value }))}
        />
        <button
          type="button"
          onClick={() => carregar(1)}
          className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-500"
        >
          Filtrar
        </button>
      </div>

      <div className="zen-card rounded-2xl overflow-hidden">
        {loading ? (
          <p className="p-6 text-gray-500">Carregando...</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 dark:bg-white/5">
                <tr>
                  <th className="px-3 py-2 text-left">Quando</th>
                  <th className="px-3 py-2 text-left">Método</th>
                  <th className="px-3 py-2 text-left">Path</th>
                  <th className="px-3 py-2 text-left">Status</th>
                  <th className="px-3 py-2 text-left">ms</th>
                  <th className="px-3 py-2 text-left">Revenda</th>
                  <th className="px-3 py-2 text-left">Erro</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id} className="border-t border-gray-100 dark:border-white/10">
                    <td className="px-3 py-2 whitespace-nowrap">{formatDateTimeBr(log.criadoEm)}</td>
                    <td className="px-3 py-2">{log.method}</td>
                    <td className="px-3 py-2 max-w-md truncate" title={log.path}>{log.path}</td>
                    <td className="px-3 py-2">{log.statusCode}</td>
                    <td className="px-3 py-2">{log.duracaoMs}</td>
                    <td className="px-3 py-2">{log.revendaId ?? (log.isSystemUser ? "MASTER" : "-")}</td>
                    <td className="px-3 py-2 max-w-xs truncate text-red-600" title={log.exception}>{log.exception || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="flex items-center justify-between">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => carregar(page - 1)}
          className="px-4 py-2 rounded-xl border disabled:opacity-50"
        >
          Anterior
        </button>
        <span className="text-sm text-gray-600 dark:text-slate-300">Página {page} de {totalPages}</span>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => carregar(page + 1)}
          className="px-4 py-2 rounded-xl border disabled:opacity-50"
        >
          Próxima
        </button>
      </div>
    </div>
  );
};

export default AuditoriaApi;
